import { type Locale } from 'invictus-sdk-typescript'

import { DEFAULT_LOCALE } from '@Constants/locale'
import { type LangForLocale, type TranslationMessages } from '@Types/lang'

const loadTranslationMessages = async <LocaleString extends Locale>(
  locale?: LocaleString,
): Promise<TranslationMessages<LangForLocale<LocaleString>>> => {
  const lang = locale || DEFAULT_LOCALE

  return (await import(`../i18n/generated/common-${lang}.json`)).default
}

export const getTranslationMessages = async <LocaleString extends Locale>(
  locale: LocaleString,
): Promise<TranslationMessages<LangForLocale<LocaleString>>> => {
  try {
    if (locale === DEFAULT_LOCALE) {
      return await loadTranslationMessages()
    }

    const [localeMessages, fallbackMessages] = await Promise.all([
      loadTranslationMessages(locale),
      loadTranslationMessages(),
    ])

    return { ...fallbackMessages, ...localeMessages }
  } catch {
    // TODO: Log error?
    // Fallback when the translation file doesn't exist
    return loadTranslationMessages()
  }
}
